// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__FYLO1","loading-icon":"Loading_loading-icon__pVsr9","wtb-loading":"Loading_wtb-loading__k+Qi7"};